import type {NavigationGuard} from 'vue-router';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';

export const salesChannelsGuard: NavigationGuard = () => {
  const {isSalesChannelsAccessible} = useServiceAccount();

  if (isSalesChannelsAccessible.value) {
    return true;
  }

  return {name: 'dashboard'};
};
